import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
export function CookiePolicyPage() {
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-3328">
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-3329">
        <Link to="/" className="flex items-center gap-2" data-id="element-3330">
          <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-3331"></div>
          <span className="font-bold text-xl tracking-tight" data-id="element-3332">
            Citiplots.com
          </span>
        </Link>
      </header>

      <main className="flex-1 max-w-4xl mx-auto px-6 py-12" data-id="element-3333">
        <h1 className="text-4xl font-bold mb-4" data-id="element-3334">Cookie Policy</h1>
        <p className="text-sm text-gray-500 mb-8 font-mono" data-id="element-3335">
          Last Updated: January 2024
        </p>

        <div className="bg-white border border-gray-300 p-8 space-y-8" data-id="element-3336">
          {/* Introduction */}
          <section data-id="element-3337">
            <h2 className="text-2xl font-bold mb-4" data-id="element-3338">1. Introduction</h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-3339">
              This Cookie Policy explains how Citiplots Private Limited ("we",
              "us", or "our") uses cookies and similar technologies on our
              website citiplots.com (the "Site"). By using our Site, you consent
              to the use of cookies as described in this policy.
            </p>
          </section>

          {/* What Are Cookies */}
          <section data-id="element-3340">
            <h2 className="text-2xl font-bold mb-4" data-id="element-3341">2. What Are Cookies</h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-3342">
              Cookies are small text files that are placed on your device when
              you visit a website. They are widely used to make websites work
              more efficiently and provide information to website owners.
            </p>
            <p className="text-gray-700 leading-relaxed" data-id="element-3343">
              Cookies can be "persistent" or "session" cookies. Persistent
              cookies remain on your device after you close your browser, while
              session cookies are deleted when you close your browser.
            </p>
          </section>

          {/* Types of Cookies */}
          <section data-id="element-3344">
            <h2 className="text-2xl font-bold mb-4" data-id="element-3345">
              3. Types of Cookies We Use
            </h2>

            <div className="space-y-4" data-id="element-3346">
              <div className="p-4 border border-gray-200 bg-gray-50" data-id="element-3347">
                <h3 className="font-bold mb-2" data-id="element-3348">3.1 Essential Cookies</h3>
                <p className="text-sm text-gray-700" data-id="element-3349">
                  These cookies are necessary for the Site to function properly.
                  They enable core functionality such as security, network
                  management, and accessibility. You cannot opt-out of these
                  cookies.
                </p>
                <p className="text-xs text-gray-500 mt-2" data-id="element-3350">
                  Examples: Authentication cookies, security cookies, load
                  balancing cookies
                </p>
              </div>

              <div className="p-4 border border-gray-200 bg-gray-50" data-id="element-3351">
                <h3 className="font-bold mb-2" data-id="element-3352">3.2 Analytics Cookies</h3>
                <p className="text-sm text-gray-700" data-id="element-3353">
                  These cookies help us understand how visitors interact with
                  our Site by collecting and reporting information anonymously.
                  We use Google Analytics and Mixpanel for this purpose.
                </p>
                <p className="text-xs text-gray-500 mt-2" data-id="element-3354">
                  Examples: _ga, _gid, _gat (Google Analytics), mp_* (Mixpanel)
                </p>
              </div>

              <div className="p-4 border border-gray-200 bg-gray-50" data-id="element-3355">
                <h3 className="font-bold mb-2" data-id="element-3356">3.3 Functional Cookies</h3>
                <p className="text-sm text-gray-700" data-id="element-3357">
                  These cookies enable enhanced functionality and
                  personalization, such as remembering your preferences and
                  settings.
                </p>
                <p className="text-xs text-gray-500 mt-2" data-id="element-3358">
                  Examples: Language preferences, region settings, display
                  preferences
                </p>
              </div>

              <div className="p-4 border border-gray-200 bg-gray-50" data-id="element-3359">
                <h3 className="font-bold mb-2" data-id="element-3360">3.4 Advertising Cookies</h3>
                <p className="text-sm text-gray-700" data-id="element-3361">
                  These cookies are used to deliver advertisements that are
                  relevant to you. They also limit the number of times you see
                  an advertisement and help measure the effectiveness of
                  advertising campaigns.
                </p>
                <p className="text-xs text-gray-500 mt-2" data-id="element-3362">
                  Examples: Facebook Pixel, Google Ads cookies, LinkedIn Insight
                  Tag
                </p>
              </div>
            </div>
          </section>

          {/* Third-Party Cookies */}
          <section data-id="element-3363">
            <h2 className="text-2xl font-bold mb-4" data-id="element-3364">4. Third-Party Cookies</h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-3365">
              We use services from third-party companies that may set cookies on
              your device. These companies include:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4" data-id="element-3366">
              <li data-id="element-3367">
                <strong data-id="element-3368">Google Analytics:</strong> For website analytics and
                performance monitoring
              </li>
              <li data-id="element-3369">
                <strong data-id="element-3370">Mixpanel:</strong> For user behavior analytics and
                product insights
              </li>
              <li data-id="element-3371">
                <strong data-id="element-3372">Facebook:</strong> For social media integration and
                advertising
              </li>
              <li data-id="element-3373">
                <strong data-id="element-3374">LinkedIn:</strong> For professional networking and
                advertising
              </li>
              <li data-id="element-3375">
                <strong data-id="element-3376">Razorpay:</strong> For payment processing
              </li>
            </ul>
          </section>

          {/* Managing Cookies */}
          <section data-id="element-3377">
            <h2 className="text-2xl font-bold mb-4" data-id="element-3378">5. Managing Cookies</h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-3379">
              You can control and manage cookies in various ways:
            </p>

            <div className="space-y-3" data-id="element-3380">
              <div className="p-4 border border-gray-200" data-id="element-3381">
                <h3 className="font-bold text-sm mb-2" data-id="element-3382">Browser Settings</h3>
                <p className="text-sm text-gray-700" data-id="element-3383">
                  Most browsers allow you to refuse or accept cookies. You can
                  usually find these settings in the "Options" or "Preferences"
                  menu of your browser. Note that blocking all cookies may
                  impact your experience on our Site.
                </p>
              </div>

              <div className="p-4 border border-gray-200" data-id="element-3384">
                <h3 className="font-bold text-sm mb-2" data-id="element-3385">
                  Cookie Preference Center
                </h3>
                <p className="text-sm text-gray-700 mb-3" data-id="element-3386">
                  You can manage your cookie preferences using our Cookie
                  Preference Center:
                </p>
                <button className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-3387">
                  Manage Cookie Preferences
                </button>
              </div>

              <div className="p-4 border border-gray-200" data-id="element-3388">
                <h3 className="font-bold text-sm mb-2" data-id="element-3389">Opt-Out Links</h3>
                <p className="text-sm text-gray-700 mb-2" data-id="element-3390">
                  You can opt-out of specific third-party cookies:
                </p>
                <ul className="text-sm text-blue-600 space-y-1" data-id="element-3391">
                  <li data-id="element-3392">
                    <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" className="hover:underline" data-id="element-3393">
                      Google Analytics Opt-out
                    </a>
                  </li>
                  <li data-id="element-3394">
                    <a href="https://www.facebook.com/help/568137493302217" target="_blank" rel="noopener noreferrer" className="hover:underline" data-id="element-3395">
                      Facebook Opt-out
                    </a>
                  </li>
                  <li data-id="element-3396">
                    <a href="https://www.linkedin.com/psettings/guest-controls" target="_blank" rel="noopener noreferrer" className="hover:underline" data-id="element-3397">
                      LinkedIn Opt-out
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          {/* Cookie Lifespan */}
          <section data-id="element-3398">
            <h2 className="text-2xl font-bold mb-4" data-id="element-3399">6. Cookie Lifespan</h2>
            <div className="overflow-x-auto" data-id="element-3400">
              <table className="w-full border border-gray-300 text-sm" data-id="element-3401">
                <thead className="bg-gray-50" data-id="element-3402">
                  <tr data-id="element-3403">
                    <th className="border border-gray-300 p-2 text-left" data-id="element-3404">
                      Cookie Type
                    </th>
                    <th className="border border-gray-300 p-2 text-left" data-id="element-3405">
                      Lifespan
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-3406">
                  <tr data-id="element-3407">
                    <td className="border border-gray-300 p-2" data-id="element-3408">
                      Session Cookies
                    </td>
                    <td className="border border-gray-300 p-2" data-id="element-3409">
                      Deleted when browser closes
                    </td>
                  </tr>
                  <tr data-id="element-3410">
                    <td className="border border-gray-300 p-2" data-id="element-3411">
                      Authentication Cookies
                    </td>
                    <td className="border border-gray-300 p-2" data-id="element-3412">30 days</td>
                  </tr>
                  <tr data-id="element-3413">
                    <td className="border border-gray-300 p-2" data-id="element-3414">
                      Analytics Cookies
                    </td>
                    <td className="border border-gray-300 p-2" data-id="element-3415">2 years</td>
                  </tr>
                  <tr data-id="element-3416">
                    <td className="border border-gray-300 p-2" data-id="element-3417">
                      Preference Cookies
                    </td>
                    <td className="border border-gray-300 p-2" data-id="element-3418">1 year</td>
                  </tr>
                  <tr data-id="element-3419">
                    <td className="border border-gray-300 p-2" data-id="element-3420">
                      Advertising Cookies
                    </td>
                    <td className="border border-gray-300 p-2" data-id="element-3421">90 days</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* Updates */}
          <section data-id="element-3422">
            <h2 className="text-2xl font-bold mb-4" data-id="element-3423">
              7. Updates to This Policy
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-3424">
              We may update this Cookie Policy from time to time to reflect
              changes in our practices or for other operational, legal, or
              regulatory reasons. We will notify you of any material changes by
              posting the new policy on this page and updating the "Last
              Updated" date.
            </p>
          </section>

          {/* Contact */}
          <section data-id="element-3425">
            <h2 className="text-2xl font-bold mb-4" data-id="element-3426">8. Contact Us</h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-3427">
              If you have questions about our use of cookies, please contact us:
            </p>
            <div className="p-4 bg-gray-50 border border-gray-200" data-id="element-3428">
              <p className="text-sm" data-id="element-3429">
                <strong data-id="element-3430">Email:</strong> privacy@citiplots.com
              </p>
              <p className="text-sm" data-id="element-3431">
                <strong data-id="element-3432">Address:</strong> 123 Business Park, Hinjewadi Phase 1,
                Pune, Maharashtra 411057
              </p>
              <p className="text-sm" data-id="element-3433">
                <strong data-id="element-3434">Phone:</strong> +91 123 456 7890
              </p>
            </div>
          </section>
        </div>

        {/* Related Links */}
        <div className="mt-8 p-6 bg-white border border-gray-300" data-id="element-3435">
          <h3 className="font-bold mb-4" data-id="element-3436">Related Policies</h3>
          <div className="flex flex-wrap gap-4" data-id="element-3437">
            <Link to="/privacy" className="text-blue-600 hover:underline text-sm" data-id="element-3438">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-blue-600 hover:underline text-sm" data-id="element-3439">
              Terms of Use
            </Link>
            <Link to="/accessibility" className="text-blue-600 hover:underline text-sm" data-id="element-3440">
              Accessibility Policy
            </Link>
          </div>
        </div>
      </main>

      <Footer data-id="element-3441" />
    </div>;
}